import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { propTypesDataHeaderHomepage } from './HeaderHomepage.proptypes';

import Text from '../../../../ui/Atoms/Text';

import { addTrackingParamsToUrl } from '../../../utils/trackingParams';
import { Typewriter } from './Typewriter';

import Button, {
  ButtonAppearance,
  ButtonTheme,
} from '../../../../ui/Atoms/Button';
import * as S from './HeaderHomepage.styles';

const HomepageButton = ({ button, index }) => {
  const {
    header_cta_label: label,
    header_cta_link: { url, target },
    header_cta_datatrack: datatrackAttribute,
  } = button || {};

  if (!url || !label) {
    return null;
  }

  const [link, setLink] = useState(url);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLink(addTrackingParamsToUrl(url));
    }, 500);

    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const handleCookieChange = () => {
      setLink(addTrackingParamsToUrl(url));
    };

    document.addEventListener('cookiechange', handleCookieChange);

    return () => {
      document.removeEventListener('cookiechange', handleCookieChange);
    };
  }, []);

  return (
    <Button
      dataTrackAttribute={datatrackAttribute}
      link={link}
      appearance={
        index === 0 ? ButtonAppearance.PRIMARY : ButtonAppearance.OUTLINE
      }
      target={target}
      theme={ButtonTheme.WOOCLAP}
    >
      {label}
    </Button>
  );
};

export const HeaderHomepageSlice = ({ slice }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const {
    header_homepage_slice_id: id,
    header_title: { html: title } = {},
    header_title_with_dynamic_text: { html: titleDynamicText } = {},
    header_dynamic_text: dynamicText,
    header_subtitle: subtitle,
  } = data || '';

  const buttonList = slice.items?.slice(0, 2) || [];

  let wordDynamicText = [];

  if (dynamicText !== '') {
    wordDynamicText = dynamicText.split(';');
  }

  const flatMap = (array, fn) => {
    let result = [];
    for (let i = 0; i < array.length; i++) {
      const mapping = fn(array[i]);
      result = result.concat(mapping);
    }
    result.pop();
    return result;
  };

  let titleWithDynamicText = titleDynamicText.replace('<h2>', '');
  titleWithDynamicText = titleWithDynamicText.replace('</h2>', '');

  const result = flatMap(
    titleWithDynamicText.split('{{dynamic_text}}'),
    part => [
      part,
      <Typewriter
        autoloop={true}
        delaySpeed='500'
        deleteSpeed='60'
        key={0}
        typeSpeed='90'
        words={wordDynamicText}
      />,
    ]
  );

  if (!title) {
    return null;
  }

  return (
    <S.HeaderHomepage id={id}>
      <S.Wrapper>
        <S.ContentContainer>
          <Text>{title}</Text>
          <S.TitleDynamicWrapper>
            {result}
            <noscript>{wordDynamicText[0]}</noscript>
          </S.TitleDynamicWrapper>

          <S.Subtitle>{subtitle}</S.Subtitle>
          <S.ButtonWrapper>
            {buttonList?.map((button, index) => (
              <HomepageButton
                button={button}
                key={`header-homepage-button-${index}`}
                index={index}
              />
            ))}
          </S.ButtonWrapper>
        </S.ContentContainer>
      </S.Wrapper>
    </S.HeaderHomepage>
  );
};

HeaderHomepageSlice.propTypes = {
  /**
   * Content of the HeaderBasic slice.
   */
  slice: PropTypes.shape(propTypesDataHeaderHomepage),
};
